import { render } from "./GoalScorers.vue?vue&type=template&id=6cb6ed8f&scoped=true"
import script from "./GoalScorers.vue?vue&type=script&lang=js"
export * from "./GoalScorers.vue?vue&type=script&lang=js"

import "./GoalScorers.vue?vue&type=style&index=0&id=6cb6ed8f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb6ed8f"]])

export default __exports__